"use client";

import { useLocale } from "@/components/i18n/LocaleProvider";
import { getBrevoBorderlessCalendarSrc } from "@/lib/brevoMeetingEmbed";
import { useRef } from "react";

export const SLBrevoCalendarIframe = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { locale } = useLocale();
  const src = getBrevoBorderlessCalendarSrc(locale);

  return (
    <iframe
      ref={iframeRef}
      loading="lazy"
      style={{
        border: "none",
      }}
      width="100%"
      height={1000}
      src={src}
    />
  );
};
